import {
  forwardRef,
  type ComponentPropsWithoutRef,
  type PropsWithChildren,
} from "react";

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

interface Props extends ComponentPropsWithoutRef<"span"> {
  variant?: "default" | "notice" | "information" | "pending" | "alert";
  emphasis?: boolean;
}

export type BadgeProps = PropsWithChildren<Props>;

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ variant = "default", emphasis, className, children, ...props }, ref) => {
    return (
      <span
        ref={ref}
        {...props}
        className={twMerge(
          "inline-flex items-center justify-center h-6 font-bold text-2xs px-2",
          "bg-v2-cosmic/50 border border-v2-gray/100 rounded text-v2-interstellar/300",
          clsx({
            "text-v2-alien/400 bg-v2-highlight-notice border-v2-notice":
              variant === "notice",
            "text-v2-action bg-v2-highlight-information border-v2-light":
              variant === "information",
            "text-v2-sun/600 bg-v2-sun/200 border-v2-sun/600":
              variant === "pending",
            "text-v2-venus/600 bg-v2-highlight-alert border-v2-alert":
              variant === "alert",
            "bg-v2-gray/200 border-v2-gray/200 text-white": emphasis,
            "bg-v2-action-positive border-v2-action-positive":
              variant === "notice" && emphasis,
            "bg-v2-cosmic/400 border-v2-cosmic/400":
              variant === "information" && emphasis,
            "bg-v2-sun/600 border-v2-sun/600":
              variant === "pending" && emphasis,
            "bg-v2-venus/400 border-v2-venus/400":
              variant === "alert" && emphasis,
          }),
          className,
        )}
      >
        {children}
      </span>
    );
  },
);
